"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHInputKeyKeyFromAxis = void 0;
const KHInputKeyDerived_1 = require("./KHInputKeyDerived");
/**
 * Converts an axis to a key based on a given threshold. If threshold is
 * positive, it will check if the axis value is >= threshold. If the threshold is
 * negative, it will check that the axis value is <= threshold.
 */
class KHInputKeyKeyFromAxis extends KHInputKeyDerived_1.KHInputKeyDerived {
    constructor(inputSet, source, threshold) {
        super(inputSet);
        this.source = source;
        this.threshold = threshold;
    }
    updateDerivedInput(_now, _delta) {
        if (this.threshold < 0) {
            this.update(this.source.getValue() <= this.threshold);
        }
        else {
            this.update(this.source.getValue() >= this.threshold);
        }
    }
}
exports.KHInputKeyKeyFromAxis = KHInputKeyKeyFromAxis;
